import { render, staticRenderFns } from "./StepPrepayPage.vue?vue&type=template&id=a481e54a&scoped=true"
import script from "./StepPrepayPage.vue?vue&type=script&lang=js"
export * from "./StepPrepayPage.vue?vue&type=script&lang=js"
import style0 from "./StepPrepayPage.vue?vue&type=style&index=0&id=a481e54a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a481e54a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a481e54a')) {
      api.createRecord('a481e54a', component.options)
    } else {
      api.reload('a481e54a', component.options)
    }
    module.hot.accept("./StepPrepayPage.vue?vue&type=template&id=a481e54a&scoped=true", function () {
      api.rerender('a481e54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reservations/advance/steps/StepPrepayPage.vue"
export default component.exports